import React, { Component, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from "react-cookie";
import { ShoppingOutlined } from '@ant-design/icons';
import { Layout, Col, Row, Typography, Badge, Collapse } from 'antd';


//componentes
import MyHeader from './Header';
import FooterSne from './Footer';
import { User } from "../../Hooks/Logged"
import { Carrito, SetCarrito } from "../../Hooks/Carrito"
import FloatingButton from "../Widgets/Floating Button/FloatingButton";

//styles
import '../../Styles/Modules/Landing.scss'

const { Content } = Layout
const { Title, Text, Paragraph } = Typography

const Section = (props) => <section {...props}>{props.children}</section>


class FAQ extends Component {

    constructor(props) {
        super(props)
        this.state = {
            openDrawer: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    items = [
        {
            key: '1',
            label: <Title level={5}>How does SneaCare work?</Title>,
            children: <>
                <Paragraph>At SneaCare, we specialize in deep cleaning for all types of footwear: sneakers, loafers, dress shoes, heels, and more. We also work with all types of materials.</Paragraph>
                <Paragraph>We offer the following services:</Paragraph>
                <ul>
                    <li>Everyday SneaCare – $25: For everyday shoes or those valued under $200 (Nike, On Cloud, New Balance, etc.)</li>
                    <li>SneaCare Lux – $39: For designer shoes valued over $200 (Golden Goose, Prada, Gucci, etc.)</li>
                </ul>

                <Paragraph>We offer pick-up & delivery between 9:00 AM and 2:00 PM. 🚙✨</Paragraph>
            </>,
        },
        {
            key: '2',
            label: <Title level={5}>Where Are You Located?</Title>,
            children: <>
                <Paragraph>Our store is located at:</Paragraph>

                <Paragraph>📍 2749 Coral Way, Miami, FL 33145</Paragraph>

                <Paragraph>
                    🕒 Monday to Friday – 10:00 AM to 6:00 PM
                </Paragraph>

                <Paragraph>
                    Saturday – 11:00 AM to 2:00 PM
                </Paragraph>

                <Paragraph>
                    You can also drop off your shoes at our partner locations:
                </Paragraph>

                <Paragraph>
                    Hyp Brickell Village or Hyp World Center
                </Paragraph>
            </>,
        },
        {
            key: '3',
            label: <Title level={5}>Turnaround Time</Title>,
            children: <>
                <Paragraph>
                    ⏱️ Our standard turnaround time is 5 business days. We also offer a 24-hour express service for an additional $12 per pair.
                </Paragraph>
            </>,
        },
        {
            key: '4',
            label: <Title level={5}>How do you clean the shoes?</Title>,
            children: <>
                <Paragraph>
                    We do a deep cleaning that includes soles, midsoles, interior, exterior, and laces.
                </Paragraph>

                <Paragraph>
                    We use specific products tailored to each material to ensure the best care for your shoes. 👟🫧
                </Paragraph>
            </>,
        }
    ]

    render() {
        return (
            <>
                <Layout style={{
                    background: 'rgb(127,135,203)',
                    background: 'linear-gradient(180deg, rgba(127,135,203,1) 0%, rgba(255,255,255,1) 100%)',
                    height: '100vh',
                }}
                    className='landing'>
                    <MyHeader
                        {...this.props}
                        openDrawer={this.state.openDrawer}
                        setOpenDrawer={(value) => this.setState({ openDrawer: value })}
                    />
                    <Content >
                        <Row justify="center" style={{ marginTop: "130px", marginBottom: "130px" }}>
                            <Col xs={23} md={20}>
                                <Title level={3}>Frequently Asked Questions:</Title>

                                <br></br>
                                <br></br>

                                <Collapse className='faq-collapse' items={this.items}/>






















                            </Col>
                        </Row>
                        <FooterSne />
                    </Content>

                    {this.props.cart?.detalles?.length > 0 ? <FloatingButton
                        title="Nuevo registro"
                        onClick={() => this.setState({ openDrawer: true })}
                        icon={<Badge count={this.props.cart?.detalles?.length}>
                            <ShoppingOutlined style={{ color: "white", fontSize: "40px" }} />
                        </Badge>}
                    /> : null}
                </Layout>

            </>
        )
    }
}

export default props => {
    const navigate = useNavigate()

    let cart = useContext(Carrito);
    let setCart = useContext(SetCarrito)

    let user = useContext(User)
    const [cookies, setCookie] = useCookies(['cart']);

    return <FAQ
        {...props}
        cart={cart}
        setCart={setCart}
        cookies={cookies}
        setCookie={setCookie}
        user={user}
        navigate={navigate} />
}